export const SET_FORMS_LIST = "SET_FORMS_LIST";
export const UPDATE_FORMS_LIST = "UPDATE_FORMS_LIST";
export const UPDATE_FORM = "UPDATE_FORM";
export const DELETE_FORM = "DELETE_FORM";
